const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/**
 * The sales/preview token as Zenpost issued it: a UUID. Links pasted into a
 * WhatsApp message pick up whatever follows them in the sentence — on
 * 2026-10-09 one in seven checkout lookups arrived as `<uuid>;` — and a token
 * with a trailing character is not found, so the checkout lost the lead's
 * phone (and with it the add-ons that only load for a known phone). Keep the
 * UUID and drop the rest; anything that is not a UUID is returned trimmed.
 */
/**
 * The token to store on an order: the cleaned UUID, or null for anything that is not one. A
 * free-text value is never written, so the column can be joined to Zenpost's tokens as is.
 */
export function salesTokenForOrder(raw: string | null | undefined): string | null {
  const value = cleanSalesToken(raw);
  return new RegExp(`^${UUID_RE.source}$`, "i").test(value) ? value : null;
}

export function cleanSalesToken(raw: string | null | undefined): string {
  const value = (raw ?? "").trim();
  if (!value) return "";
  const match = value.match(UUID_RE);
  return match ? match[0].toLowerCase() : value;
}
